export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.67475 13.1274C1.04956 13.1274 0.761825 12.3496 1.23651 11.9427L3.83535 9.7151C4.08753 9.49895 4.45966 9.49895 4.71184 9.7151L7.31068 11.9427C7.78536 12.3496 7.49763 13.1274 6.87243 13.1274H1.67475Z"
      fill="currentColor"
    />
    <path
      d="M7.59705 19.5093C11.8242 21.9511 17.2295 20.5042 19.6714 16.277C19.9427 15.8074 19.7819 15.2067 19.3122 14.9354C18.8426 14.6641 18.2419 14.8249 17.9706 15.2946C16.0714 18.5824 11.8673 19.7078 8.57951 17.8085C6.5991 16.6645 5.40326 14.6843 5.18043 12.5718L3.22374 12.8134L3.28635 13.2285C3.68781 15.7727 5.19272 18.1204 7.59705 19.5093Z"
      fill="currentColor"
    />
    <path
      d="M22.3245 10.5889C22.9496 10.5882 23.2383 11.3657 22.7641 11.7731L20.1678 14.0037C19.9159 14.2202 19.5438 14.2206 19.2914 14.0047L16.6899 11.7802C16.2148 11.3739 16.5016 10.5957 17.1268 10.595L22.3245 10.5889Z"
      fill="currentColor"
    />
    <path
      d="M16.3946 4.21389C12.1647 1.77696 6.76104 3.23024 4.3241 7.46021C4.05335 7.93017 4.21484 8.53063 4.6848 8.80138C5.15476 9.07213 5.75523 8.91064 6.02598 8.44068C7.92141 5.15063 12.1241 4.02033 15.4142 5.91577C17.3959 7.05747 18.5941 9.03631 18.8194 11.1486L20.7758 10.9047L20.7127 10.4897C20.3082 7.94588 18.8006 5.59999 16.3946 4.21389Z"
      fill="currentColor"
    />
  </svg>
);
